import {useEffect, useRef, useState} from "react";

const questions = [
    {
        id: 1,
        title: "Сколько записей (приемов) в среднем в месяц в Вашей клинике?",
        hint: "Укажите общее количество записей пациентов на прием к специалистам за месяц.",
        type: "number",
        placeholder: "Введите число",
        isInit: true,
    },
    {
        id: 2,
        title: "Сколько в среднем клиент платит за посещение клиники",
        hint: "Укажите среднюю сумму, которую платит Ваш клиент при посещении клиники",
        type: "number",
        placeholder: "Введите число",
        isInit: true,
    },
    {
        id: 3,
        title: "Вы напоминаете клиентам о визите?",
        hint: "Укажите примерное количество SMS-напоминаний и уведомлений.",
        type: "bool",
        placeholder: "Напоминаем",
        isInit: true,
    },
    {
        id: 4,
        title: "Как Вы напоминаете пациентам о записи?",
        hint: "Выберите 1 или несколько вариантов",
        type: "select",
        options: [
            {value: 'sms', text: 'SMS'},
            {value: 'messenger', text: 'сообщения в мессенджерах'},
            {value: 'call', text: 'звонит менеджер'},
            {value: 'autocall', text: 'звонит робот'},
            {value: 'other', text: 'другое'},
        ],
        useConditions: [{2: true}],
    },
    {
        id: 5,
        title: "Сколько Вы тратите на СМС в месяц?",
        hint: "Укажите среднюю сумму, которую платит Ваша организация за рассылки",
        type: "number",
        placeholder: "Введите число",
        useConditions: [{3: 'sms'}],
    },
    {
        id: 6,
        title: "Сколько Вы тратите на звонки в месяц?",
        hint: "Укажите среднюю сумму, которую платит Ваша организация за рассылки",
        type: "number",
        placeholder: "Введите число",
        useConditions: [{3: 'call'}],
    },
    {
        id: 7,
        title: "Вы напоминаете всем клиентам?",
        hint: "Какому количеству клиентов Вы напоминаете? Если всем, напишите 100",
        type: "number",
        placeholder: "Введите число процентов",
        useConditions: [{2: true}],
    },
    // {
    //     id: 4,
    //     title: "Сколько администраторов участвует в коммуникациях?",
    //     hint: "Укажите количество сотрудников.",
    //     type: "number",
    //     placeholder: "Введите число",
    //     isInit: true,
    // }
];
const Calculator = props => {
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [questionsNeed, setQuestionsNeed] = useState([]);
    const [recomendations, setRecomendations] = useState({});
    const [answers, setAnswers] = useState({});
    const [canGet, setCanGet] = useState(0);
    const [selected, setSelected] = useState([]);

    const inputRef = useRef(null);

    useEffect(() => {
        let arr = [];
        questions.map((question, key) => {
            if (question.isInit) arr.push(key);
            if (question.useConditions) question.useConditions.forEach(condition => {
                let isUse = true;
                Object.keys(condition).forEach(conditionItem => {
                    if ((!Array.isArray(answers[conditionItem]) && condition[conditionItem] !== answers[conditionItem]) ||
                        (Array.isArray(answers[conditionItem]) && !answers[conditionItem].includes(condition[conditionItem]))) isUse = false;
                })
                if (isUse) arr.push(key);
            })
        });
        setQuestionsNeed(arr)

        if (Object.values(answers).length < arr.length && Object.values(answers).length > 0) setCurrentQuestion(currentQuestion + 1)
    }, [answers]);

    const handleAnswer = () => {
        let tmp = Object.assign({}, answers);
        if ((inputRef && inputRef.current) || questions[currentQuestion].type === 'select') {
            switch (questions[currentQuestion].type) {
                case 'bool':
                    tmp[currentQuestion] = inputRef.current.checked;
                    inputRef.current.checked = true;
                    break;
                case 'select':
                    tmp[currentQuestion] = selected;
                    setSelected([])
                    break;
                case 'number':
                    tmp[currentQuestion] = inputRef.current.value;
                    inputRef.current.value = "";
                    break;
            }
            setAnswers(tmp);

            let tmpRecs = Array.from(recomendations); let sum = 0;
            if (0 in tmp && 1 in tmp && 2 in tmp && tmp[2] === false) {
                tmpRecs['0_1_2'] = {
                    text: "Напоминания увеличивают доходимость в среднем на 11%",
                    profit: "+ " + ((parseInt(tmp[0]) * parseInt(tmp[1])) * .11).toLocaleString('ru-RU').toString() + " ₽/мес",
                };
                sum += (parseInt(tmp[0]) * parseInt(tmp[1])) * .11;
            }
            if (0 in tmp && 1 in tmp && 2 in tmp && tmp[2] === true) {
                if (tmp[3] && tmp[3].includes('sms') && tmp[4] && tmp[4].length > 0) {
                    tmpRecs['0_1_2_3_4'] = {
                        text: "Сократить расходы на SMS можно на 50%",
                        profit: "+ " + (parseInt(tmp[4]) * .5).toLocaleString('ru-RU').toString() + " ₽/мес",
                    };
                    sum += parseInt(tmp[4]) * .5;
                }
                if (tmp[3] && tmp[3].includes('call') && tmp[5] && tmp[5].length > 0) {
                    tmpRecs['0_1_2_3_5'] = {
                        text: "Сократить расходы на звонки можно на 70%",
                        profit: "+ " + (parseInt(tmp[5]) * .7).toLocaleString('ru-RU').toString() + " ₽/мес",
                    };
                    sum += parseInt(tmp[5]) * .7;
                }

                if (tmp[6] && parseInt(tmp[6]) !== 100) {
                    tmpRecs['0_1_2_6'] = {
                        text: "Напоминания увеличивают доходимость в среднем на 11%",
                        profit: "+ " + ((parseInt(tmp[0]) * parseInt(tmp[1])) / (100 - parseInt(tmp[6])) * (100 - (100 - parseInt(tmp[6]))) * .11).toLocaleString('ru-RU').toString() + " ₽/мес",
                    };
                    sum += ((parseInt(tmp[0]) * parseInt(tmp[1])) / (100 - parseInt(tmp[6])) * (100 - (100 - parseInt(tmp[6]))) * .11);
                }
            }

            setRecomendations(tmpRecs)
            setCanGet(sum);
        }
    }
console.log(answers, questionsNeed)
    return <section className="calculator section" id="calculator">
        <div className="container">
            <div className="section-heading">
                <p className="eyebrow">Расчет потенциала для Вашей организации</p>
                <h2>Калькулятор</h2>
            </div>

            <div className="calculator-card">
                <div className="progress-row">
                    <strong id="questionCounter">{currentQuestion + 1}/{questionsNeed.length}</strong>
                    <div className="progress"><span style={{width: questionsNeed.length > 0 ? ((currentQuestion + 1) / questionsNeed.length * 100).toString() + '%' : '100%'}} id="progressBar"></span></div>
                </div>

                <div className="question">
                    <h3 id="questionTitle">{questions[currentQuestion].title}</h3>
                    <p id="questionHint">{questions[currentQuestion].hint}</p>
                    {questions[currentQuestion].type === 'bool' ? <label htmlFor={'answerInput'}>
                        <input id="answerInput" defaultChecked={true} type="checkbox" ref={inputRef}/>
                        {questions[currentQuestion].placeholder}
                    </label> : (questions[currentQuestion].type === 'select' ? questions[currentQuestion].options.map(item => {
                        return <label htmlFor={'answerInput_' + item.value}>
                            <input id={'answerInput_' + item.value} key={'answerInput_' + item.value} defaultChecked={false} type="checkbox" onClick={e => {
                                let tmp = Array.from(selected);
                                if (e.target.checked) tmp.push(item.value)
                                else tmp.splice(tmp.findIndex(subitem => subitem === item.value), 1)
                                setSelected(tmp)
                            }}/>
                            {item.text}
                        </label>
                    }) : <input id="answerInput" type="number" min="0" inputMode="numeric" ref={inputRef}
                           placeholder={questions[currentQuestion].placeholder}/>)}
                    {Object.keys(answers).length < questionsNeed.length && <button className="button button-primary next-button" id="nextButton" onClick={() => handleAnswer()} type="button"> Далее <span>→</span></button>}
                </div>

                <div className="result-box">
                    <div className="result-list">
                        <h4>{Object.keys(answers).length < questionsNeed.length ? 'Промежуточный' : 'Итоговый'} результат</h4>
                        {Object.values(recomendations).map((item, key) => {
                            return <div key={key} className="result-row">
                                <span className="result-icon">➤</span>
                                <span>{item.text}</span>
                                <b>{item.profit}</b>
                            </div>
                        })}
                        {/*<div className="result-row"><span className="result-icon">☎</span><span>Снижение затрат на звонки</span><b>от*/}
                        {/*    35 000 ₽/мес</b></div>*/}
                        {/*<div className="result-row"><span className="result-icon">SMS</span><span>Снижение затрат на SMS</span><b>от*/}
                        {/*    18 500 ₽/мес</b></div>*/}
                        {/*<div className="result-row"><span className="result-icon">➤</span><span>Перевод пациентов в мессенджеры</span><b>от*/}
                        {/*    22 300 ₽/мес</b></div>*/}
                        {/*<div className="result-row"><span className="result-icon">◷</span><span>Экономия времени администраторов</span><b>от*/}
                        {/*    51 800 ₽/мес</b></div>*/}
                    </div>
                    {canGet > 0 && <div className="total-result">
                        <span>Потенциальный<br/>дополнительный доход</span>
                        <strong id="totalIncome">{(canGet * 12).toLocaleString('ru-RU')} ₽ в год</strong>
                        <small>или {canGet.toLocaleString('ru-RU')} ₽ в месяц</small>
                    </div>}
                </div>

                <p className="source-note">Расчеты основаны на нашем <a href="#reports">опыте при работе с
                    клиниками</a> и <a href="#research">исследовании рынка мед. услуг</a>.</p>
            </div>
        </div>
    </section>
}

export default Calculator;